import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';

import avec1 from './avec1.png';
import avec2 from './avec2.png';
import avec3 from './avec3.png';
import avec4 from './avec4.png';

import sans1 from './sans1.png';
import sans2 from './sans2.png';
import sans3 from './sans3.png';
import sans4 from './sans4.png';

import { NamedLink } from '../../components';

import like from './like.svg';
import dislike from './dislike.svg';

import css from './SectionHowItWorks.module.css';

const SectionHowItWorks = props => {
  const { rootClassName, className } = props;

  const classes = classNames(rootClassName || css.root, className);
  return (
    <div className={classes}>
      <div className={css.title}>
       <span className={css.boldTitle}>La location de parking</span> <FormattedMessage id="SectionHowItWorks.titleLineOne" />
      </div>
      <div className={css.sectionsWrapper}>

        <div className={css.leftSection}>
          
          <ul>
              <li className={css.firstItem}>… Sans ollo !</li>
              <li> 🤞 Effectuez une demande auprès d’un propriétaire et espérez une réponse... </li>
              <li> 😤 Perdez du temps à devoir organiser ensemble la remise des accès.</li>
              <li> 💸 Payez un prix souvent abusif fixé par le propriétaire et souvent en liquide.</li>
              <li> 🥺 Vous êtes livrés à vous-même si votre hôte ne répond pas.</li>
            </ul>

        </div>

        <div className={css.rightSection}>
        <ul>
            <li className={css.firstItem}>… Avec ollo !</li>
            <li> 🤩 Réservez instantanément une place qui vous correspond, pour la durée qui vous correspond !</li>
            <li> 🧘‍♀️ Garez-vous en totale autonomie, sans même rencontrer votre hôte !</li>
            <li> 💳 Un paiement sécurisé et des prix justes et dégressifs !</li>
            <li> 🧑‍💻 Une assistance 7j / 7 pour vous accompagner du début à la fin !</li>
          </ul>
            
        </div>

      </div>

    </div>
  );
};

SectionHowItWorks.defaultProps = { rootClassName: null, className: null };

const { string } = PropTypes;

SectionHowItWorks.propTypes = {
  rootClassName: string,
  className: string,
};

export default SectionHowItWorks;
